import { FacilityRequests } from '@/services/facility.requests'
const facilityService = new FacilityRequests()

const state = {
  list: []
}

const actions = {
  async list ({ state }) {
    try {
      state.list = await facilityService.list()
      return state.list
    } catch (err) {
      return err
    }
  }
}

const mutations = {
  setList (state, list) {
    state.list = list
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
